/**
 * Press release status constants - eliminates magic strings throughout the codebase
 */
const PRESS_RELEASE_STATUS = {
  PAID: 'PAID',
  PENDING: 'PENDING',
};

export default PRESS_RELEASE_STATUS;
